import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-search-header-item-amount',
  templateUrl: './search-header-item-amount.component.html',
  styleUrls: ['./search-header-item-amount.component.css']
})
export class SearchHeaderItemAmountComponent implements OnInit {

  @Input() itemCount: number;

  constructor(public translate: TranslateService = null){
    
    
  }
  
  get itemCountDescription(): string {
    if (this.itemCount > 1)
      return this.translate.instant('multiItemFounds.TITLE');
    else
      return this.translate.instant('singleItemFound.TITLE');
  }

  ngOnInit() {
  }

}
